var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "contentContainer", staticClass: "scrolling-text container" },
    [
      _c(
        "div",
        { staticClass: "scrolling-text__text" },
        _vm._l(_vm.blockList, function(block, index) {
          return _c("div", { key: index }, [
            _c("div", { staticClass: "scrolling-text__mobile-image" }, [
              _c("img", {
                attrs: {
                  src: block.settings.imageMobile,
                  alt: block.settings.imageAlt
                }
              })
            ]),
            _c("div", { staticClass: "scrolling-text__block" }, [
              _c("div", { staticClass: "h3 scrolling-text__header" }, [
                _vm._v(_vm._s(block.settings.title))
              ]),
              _c("div", {
                staticClass: "client-generated body-md scrolling-text__content",
                domProps: { innerHTML: _vm._s(block.settings.content) }
              })
            ])
          ])
        }),
        0
      ),
      !_vm.isMobile
        ? _c(
            "div",
            {
              staticClass: "scrolling-text__image-wrapper",
              class: _vm.getContainerClass
            },
            [
              _c("img", {
                staticClass: "scrolling-text__image",
                attrs: { src: _vm.getContentImage }
              })
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }